import type {
  IProblemRecord,
  ISection,
  ISubnavItem,
  ITableBlock,
  ITableColumn,
  ITableUI,
} from "../../../shared/ui/data-table/model/data-table-contract";

export type {
  IProblemRecord,
  ISection,
  ISubnavItem,
  ITableBlock,
  ITableColumn,
  ITableUI,
};

export const getEncounters = (store: {
  encounters: {
    encountersRecords: { data: IProblemRecord | null };
  };
}) => store.encounters.encountersRecords.data;
